<template>
  <b-modal
    :active.sync="show"
    @cancel="$emit('input', false)"
    @close="$emit('input', false)"
    :width="500"
    scroll="keep"
  >
    <div class="box form-processes-c">
      <h3 class="title is-5">
        {{ form._id ? "Actualizar" : "Crear Nuevo" }} Proceso
      </h3>

      <b-field
        label="Nombre del Proceso"
        :type="nameError ? 'is-danger' : null"
        :message="nameError"
      >
        <b-input
          v-model="form.name"
          placeholder="Ingresa el nombre del proceso"
          @input="touched.name = true"
          @blur="touched.name = true"
          autofocus
        ></b-input>
      </b-field>

      <b-field
        label="Fecha de creación"
        :type="evaluationDateError ? 'is-danger' : null"
        :message="evaluationDateError"
      >
        <b-datepicker
          v-model="form.evaluationDate"
          class="datepicker-in-modal"
          placeholder="Haga clic para seleccionar..."
          icon="calendar-today"
          icon-right-clickable
          :icon-right="form.evaluationDate ? 'close-circle' : ''"
          @icon-right-click="clearDate"
          @input="touched.evaluationDate = true"
          @blur="touched.evaluationDate = true"
          trap-focus
          append-to-body
        >
        </b-datepicker>
      </b-field>

      <b-field label="Benchmark" style="margin-top: 10px;">
        <b-radio-button
          v-model="form.benchmark"
          :native-value="0"
          type="is-danger"
        >
          <b-icon icon="database-minus-outline"></b-icon>
          Excluido
        </b-radio-button>
        <b-radio-button
          v-model="form.benchmark"
          :native-value="1"
          type="is-success"
        >
          <b-icon icon="database-plus-outline"></b-icon>
          Incluido
        </b-radio-button>
      </b-field>

      <div class="is-flex is-justify-content-space-between mt-5">
        <b-button
          class="mr-5"
          type="is-primary"
          expanded
          :disabled="!isFormValid"
          @click="handleSubmitProcess"
        >
          {{ form._id ? "Actualizar" : "Crear" }} Proceso
        </b-button>
        <b-button expanded @click="$emit('input', false)">
          Cancelar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      show: this.value,
      // Form
      form: {
        _id: null,
        name: "",
        evaluationDate: null,
        benchmark: 0,
      },
      touched: {
        name: false,
        evaluationDate: false,
        test: false,
      },
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    editForm: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    // Validate Form
    nameError() {
      if (!this.touched.name) return null;
      if (!this.form.name) return "Campo obligatorio";
      return null;
    },
    evaluationDateError() {
      if (!this.touched.evaluationDate) return null;
      if (!this.form.evaluationDate) return "Campo obligatorio";
      return null;
    },
    isFormValid() {
      const noErrors = !this.nameError && !this.evaluationDate;
      const allFilled =
        this.form.name.trim() !== "" &&
        !!this.form.evaluationDate &&
        (this.form._id ? !this.isEqualObjects(this.editForm, this.form) : true);

      return noErrors && allFilled;
    },
  },
  methods: {
    // Form
    clearForm() {
      this.form = {
        id: null,
        name: "",
        evaluationDate: null,
        benchmark: 0,
      };
      this.touched = {
        id: null,
        name: false,
        evaluationDate: false,
        benchmark: false,
      };
    },
    clearDate() {
      this.form.evaluationDate = null;
    },
    isEqualObjects(obj1, obj2) {
      return (
        JSON.stringify(obj1, Object.keys(obj1).sort()) ===
        JSON.stringify(obj2, Object.keys(obj2).sort())
      );
    },
    // Actions
    handleSubmitProcess() {
      if (!this.isFormValid) return;
      if (this.form._id) return this.$emit("handleEditProcess", this.form);
      this.$emit("handleCreateProcess", this.form);
    },
  },
  watch: {
    editForm: {
      handler(newVal) {
        if (Object.keys(newVal).length) {
          this.form = {
            ...newVal,
            benchmark: newVal.benchmark || 0,
            evaluationDate: new Date(newVal.evaluationDate),
          };
        }
      },
      deep: true,
    },
    value(newVal) {
      if (!newVal) this.clearForm();
      this.show = newVal;
    },
    show(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.option-benchmark {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/components/Process/CreateProcessModal.vue